export function initialize(gaTrackingId) {
  const gtmScript = document.createElement("script");
  gtmScript.type = "text/javascript";
  gtmScript.async = true;
  gtmScript.src = "https://www.googletagmanager.com/gtag/js?id=" + gaTrackingId;

  document.head.appendChild(gtmScript);

  window.dataLayer = window.dataLayer || [];
  function gtag() {
    window.dataLayer.push(arguments);
  }
  window.gtag = gtag;
  gtag("js", new Date());
  gtag("config", gaTrackingId);
}

function sanitizePagePath(pagePath) {
  const rawPagePath = String(pagePath || "/")
    .split("?")[0]
    .split("#")[0];
  const normalizedPagePath = rawPagePath.startsWith("/") ? rawPagePath : `/${rawPagePath}`;

  return normalizedPagePath.replace(/\/+$/, "") || "/";
}

export function sendGlobalJourneyPageView(globalMeasurementId, pageView) {
  if (!globalMeasurementId || !pageView || !window.gtag) {
    return;
  }

  const pagePath = sanitizePagePath(pageView.pagePath);

  window.gtag("event", "page_view", {
    send_to: globalMeasurementId,
    page_title: pageView.pageTitle,
    page_path: pagePath,
    page_location: `${window.location.origin}${pagePath}`,
    page_type: pageView.pageType,
    app_area: pageView.appArea
  });
}
